import React, { useState, useEffect } from "react";
import { ChangeEvent } from "react";
import useDataStore from "../Hooks/useDataStore";
import Input from "../FormUi/Input";
import { isNumber } from "lodash";
import "../../css/Global.css";

import { Field } from "../Types/Form";

import PhoneValidate from "./PhoneValidate";
import EmailValidate from "./EmailValidate";

// Компонент принимает массив объектов
// где каждый объект - элемент формы(инпут, чекбокс... )
// name - имя поля, по нему происходят все операции с элементами формы.
// !!! Старайтесь не указывать одинаковые имена для полей на одной странице !!!
// title - название элемента, демонтрируется как текст над ним
// element - по дефолту, если не заполен, рендерит Input, но так же можно указать: checkbox, textarea
// link - {linkName: Название ссылки, url: ссылка}, вставляет после title
// error - текст который отображается если элемент не прошел валидацию
// ? в ключе объекта означает что ключ является не обязательным
// Пример:
//  [
//    {
//        name: "age",
//        title: "Возраст",
//        error: "Вам должно быть не меньше 18 лет",
//        validate: (value: any) => Number(value) < 18
//    }
//  ]

// handleSubmit - функция которая будет получать заполненные данные из формы в виде
// handleSubmit(data:данные) => ваши действия

// validate - функция, которая принимает значение(value) элемента, а в теле условие валидации
// можно не заполнять, тогда произойдет дефолтная валидация на пустоту
// для почты и телефона валидация сработает сама

type props = {
    fields: Field[],
    handleSubmit: (arg:any) => any
}

const Form = ({ fields, handleSubmit }: props) => {
    const { errors, handleChange, getData } = useDataStore({ fields: fields });

    return (
        <form
            onSubmit={(event) => getData(handleSubmit, event)}
        >
            {fields.map(field =>
                <Input
                    field={field}
                    error={errors[field.name]}
                    onChange={handleChange}
                />
            )}

            <button type="submit">Отправить</button>
        </form>
    )
}

export default Form;